import imageDe from '../images/de/uploader-insuletOmnipod-problem-3.png';
import imageEn from '../images/en/uploader-insuletOmnipod-problem-3.png';
import imageEs from '../images/es/uploader-insuletOmnipod-problem-3.png';
import imageFi from '../images/fi/uploader-insuletOmnipod-problem-3.png';
import imageFr from '../images/fr/uploader-insuletOmnipod-problem-3.png';
import imageIt from '../images/it/uploader-insuletOmnipod-problem-3.png';
import imageNo from '../images/no/uploader-insuletOmnipod-problem-3.png';
import imageSv from '../images/sv/uploader-insuletOmnipod-problem-3.png';

export const uploaderDASHErrorMsgImage = {
  de() {
    return imageDe;
  },
  en() {
    return imageEn;
  },
  es() {
    return imageEs;
  },
  fi() {
    return imageFi;
  },
  fr() {
    return imageFr;
  },
  it() {
    return imageIt;
  },
  no() {
    return imageNo;
  },
  sv() {
    return imageSv;
  },
};
